<template>
  <aha-tab-item title="Log out everywhere else">
    <aha-section>
      <template #header>
        <h5>Log out everywhere else</h5>
      </template>
      <template #body>
        <div class="pb-2">
          <div class="pb-2">
            This will log you out from all other devices and browsers.
            You will still stay logged in on this device.
          </div>
        </div>

        <aha-button
          variant="danger"
          @click="logoutEveryWhere()"
          :disabled="logoutLoading"
        >
          Log out everywhere else
          <aha-spinner
            variant="white"
            v-if="logoutLoading"
            class="ml-1"
          />
        </aha-button>
      </template>
    </aha-section>
  </aha-tab-item>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import utils from '@/util'
import gaCategories from '@/constant/gaCategories'
import UserApi from '@/api/user'

export default {
  data() {
    return {
      logoutLoading: false,
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
  },
  methods: {
    async logoutEveryWhere() {
      if (this.logoutLoading) return
      this.logoutLoading = true

      try {
        const resp = await UserApi.logoutEveryWhere(this.currentUser.id)
        utils.setCookieToken(resp.token)
        Vue.http.headers.common.Authorization = `Bearer ${resp.token}`
        utils.showToastSuccess('You have successfully logged out from all other devices!')
        utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Logout everywhere else success')
      } catch {
        utils.showToastError('Something went wrong!')
        utils.gaTrackEvent(gaCategories.PRESENTATION_LIST, 'Logout everywhere else fail')
      }
      this.logoutLoading = false
    },
  },
}
</script>
